/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Banner_SubtitleInputs */

const en_homepage_banner_subtitle = /** @type {(inputs: Homepage_Banner_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`students and researchers around the world`)
};

const es_homepage_banner_subtitle = /** @type {(inputs: Homepage_Banner_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estudiantes e investigadores en todo el mundo`)
};

/**
* | output |
* | --- |
* | "students and researchers around the world" |
*
* @param {Homepage_Banner_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_banner_subtitle = /** @type {((inputs?: Homepage_Banner_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Banner_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_banner_subtitle(inputs)
	return en_homepage_banner_subtitle(inputs)
});